import { Tooltip } from "@jugl-web/ui-components/cross-platform/Tooltip";
import format from "date-fns/format";
import { FC } from "react";
import { useAgentAnalyticsContext } from "@jugl-web/domain-resources/analytics";
import { ReactComponent as CalendarIcon } from "./assets/calendar.svg";
import { ReactComponent as QuestionMarkIcon } from "./assets/question-mark.svg";

interface AnalyticsPageHeaderProps {
  title: string;
  subtitle: string;
  hints?: string[];
}

export const AnalyticsPageHeader: FC<AnalyticsPageHeaderProps> = ({
  title,
  subtitle,
  hints = [],
}) => {
  const { timeRange } = useAgentAnalyticsContext();

  const currentMonthLabel = format(new Date(timeRange.fromISO), "MMMM yyyy");

  return (
    <div className="flex items-start justify-between">
      <div className="flex flex-col gap-1">
        <span className="font-secondary text-[22px] font-semibold text-[#1A2023]">
          {title}
        </span>
        <span className="font-secondary text-sm text-[#737B7E]">
          {subtitle}
        </span>
      </div>
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-2 rounded-[10px] bg-[#F9F9F9] px-2.5 py-2">
          <CalendarIcon className="h-4 w-4 shrink-0" />
          <span className="font-secondary text-sm text-[#1A2023]">
            {currentMonthLabel}
          </span>
        </div>
        {hints.length > 0 && <HelpIcon hints={hints} />}
      </div>
    </div>
  );
};

interface HelpIconProps {
  hints: string[];
}

const HelpIcon: FC<HelpIconProps> = ({ hints }) => (
  <Tooltip
    placement="bottom"
    delay="none"
    renderTrigger={({ ref, props }) => (
      <div
        ref={ref}
        className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-grey-100 transition-colors hover:bg-grey-200"
        {...props}
      >
        <QuestionMarkIcon className="shrink-0" />
      </div>
    )}
    className="max-w-[332px] p-4"
  >
    <ul className="m-0 list-disc space-y-3 pl-4">
      {hints.map((hint, index) => (
        <li key={+index}>{hint}</li>
      ))}
    </ul>
  </Tooltip>
);
